import * as React from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // Ширина известна с ПЕРВОГО рендера, а не после первого эффекта (как в
  // исходном shadcn-хуке с `undefined`): эффекты одного коммита видят
  // значения одного и того же рендера, поэтому потребитель, решающий что-то
  // в своём эффекте на маунте (`useAutoOpenForJob`), успевал сделать это по
  // ответу «не мобила» и на мобиле. Тот же приём, что в `useIsDesktop`.
  const [isMobile, setIsMobile] = React.useState<boolean>(
    () => typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT,
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}
